import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy } from '@angular/core';
import { isNil } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@app/shared/services/auth.service';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-lamp-card',
  templateUrl: './lamp-card.component.html',
  styleUrls: ['./lamp-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LampCardComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  @Input() lamp: any;
  @Input() count = 0;
  @Input() active = false;
  @Output() cardSelect = new EventEmitter();
  isValidImage = false;

  public productPrice = 0;
  public priceLabel: string = '';

  constructor(private authService: AuthService, private azureBlobStorageService: AzureBlobStorageService, private translate: TranslateService) {}

  public ngOnInit(): void {
    this.translate
      .get('module.energyMap.lampCard')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: Record<string, string>) => {
        this.priceLabel = res.uvpText;

        if (this.authService.isKAM) {
          this.productPrice = this.lamp.salesPrice;
          this.priceLabel = res.vkText;
        } else {
          this.productPrice = this.lamp.uvpCost;
        }

        this.isValidImage = this.validateImage(this.lamp.image);
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public select(lamp: any): void {
    this.cardSelect.emit(lamp);
  }

  private validateImage(image: string): boolean {
    return !isNil(image);
  }

  public setDefaultImage(): void {
    this.lamp.image = this.azureBlobStorageService.getBlobImageSafeUrl(`${environment.tenant}/assets/images/lamps/DefaultLamp.png`);
  }
}
